<div [formGroup]="postalCodeForm" class="inputContainer" autocomplete="one-time-code">
    <input type="text" formControlName="zip" placeholder="Enter zip code"
        class="form-control form-control-custom marginRight" numbersOnly [maxLength]="5"
        (keyup)="emitValidationStatus()" autocomplete="one-time-code">
    <span>-</span>
    <input type="text" formControlName="zipExtension" placeholder="Extension"
        class="form-control form-control-custom marginLeft" [maxLength]="4" numbersOnly (keyup)="emitValidationStatus()"
        autocomplete="one-time-code">
</div>